/** Umwandlungen zwischen den Formaten der Krypto-Bibliothek und der API. */

export function bufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  // Chunkweise, weil String.fromCharCode bei großen Arrays den Stack sprengt.
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }
  return btoa(binary);
}

export function base64ToBuffer(value: string): ArrayBuffer {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

/**
 * Die Bibliothek liefert Ciphertext als "binary string" (ein Zeichen je Byte).
 * Für den Transport wird daraus Base64.
 */
export function binaryStringToBase64(value: string): string {
  return btoa(value);
}

export function base64ToBinaryString(value: string): string {
  return atob(value);
}

export function textToBuffer(text: string): ArrayBuffer {
  return new TextEncoder().encode(text).buffer as ArrayBuffer;
}

export function bufferToText(buffer: ArrayBuffer): string {
  return new TextDecoder().decode(buffer);
}
